/// <reference types="../commons.d.ts" preserve="true" />
/**
 * This module provides utilities to manage cookies in the browser.
 *
 * {@include ../lib/cookie/README.md}
 * @category Core Modules
 * @module cookie
 * @packageDocumentation
 */

import { o_util } from "@gr-common/common/namespaces";
import type { GlobalUtils } from "./index.js";

export type { SamesiteValues, SetCookieOptions, RemoveCookieOptions } from "../lib/cookie/index.js";

/**
 * Cookie namespace provides various cookie utilities
 */
export type Cookie = GlobalUtils["cookie"];

/**
 * Cookie namespace provides various cookie utilities
 */
export const cookie: Cookie = o_util.cookie ?? {};

/** Function reference to {@link Cookie.get} function */
export const exists: Cookie["exists"] = cookie.exists;

/** Function reference to {@link Cookie.get} function */
export const get: Cookie["get"] = cookie.get;

/** Function reference to {@link Cookie.remove} function */
export const remove: Cookie["remove"] = cookie.remove;

/** Function reference to {@link Cookie.set} function */
export const set: Cookie["set"] = cookie.set;
